import React from 'react';
import Container from 'common/src/components/UI/Container';
import ParticlesComponent from '../../Hosting/Particle';
import BannerWrapper from './banner.style';

const BannerSection = () => {
  return (
    <BannerWrapper id="banner_section">
      <ParticlesComponent />
      <Container className="banner_container">
        <div className="content">
          <h1 className="title">Contact us</h1>
        </div>
      </Container>
    </BannerWrapper>
  );
};

export default BannerSection;
